/* ============================================
   PLNO Theme JavaScript
   ============================================ */

function plnoCartAdd(variantId, onSuccess, onError) {
  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((r) => {
      if (!r.ok) return r.json().then((e) => Promise.reject(e));
      return r.json();
    })
    .then((item) => {
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = parseInt(countEl.textContent || '0', 10) + (item.quantity || 1);
        countEl.style.display = '';
      } else {
        fetch(window.routes.cart_url + '.js').then((r) => r.json()).then((cart) => {
          const cartLink = document.querySelector('.header-actions a[href$="/cart"]');
          if (cartLink && cart.item_count > 0) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        });
      }
      if (onSuccess) onSuccess(item);
    })
    .catch((err) => { if (onError) onError(err); });
}

function quickAddToCart(btn) {
  const card = btn.closest('.product-card');
  const activeSize = card.querySelector('.size-btn.active');
  const firstSize = card.querySelector('.size-btn');
  const variantId = activeSize ? activeSize.dataset.variantId : (firstSize ? firstSize.dataset.variantId : null);
  if (!variantId) { return; }
  const span = btn.querySelector('span');
  const original = span.textContent;
  plnoCartAdd(
    variantId,
    () => { span.textContent = 'Added'; setTimeout(() => { span.textContent = original; }, 1800); },
    () => { span.textContent = 'Sold Out'; setTimeout(() => { span.textContent = original; }, 1800); }
  );
}

document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav
  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavClose = document.querySelector('.mobile-nav-close');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => mobileNav.classList.add('open'));
    if (mobileNavClose) mobileNavClose.addEventListener('click', () => mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => mobileNav.classList.remove('open')));
  }

  // Mega menu (hover on desktop, click on touch)
  document.querySelectorAll('.nav-item').forEach((item) => {
    const link = item.querySelector('.nav-link');
    const menu = item.querySelector('.mega-menu');
    if (!menu) return;
    let closeTimer;
    const open = () => { clearTimeout(closeTimer); document.querySelectorAll('.nav-item.is-open').forEach((o) => { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); };
    const scheduleClose = () => { closeTimer = setTimeout(() => item.classList.remove('is-open'), 150); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    if (link) {
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          item.classList.contains('is-open') ? item.classList.remove('is-open') : open();
        }
      });
    }
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-item')) document.querySelectorAll('.nav-item.is-open').forEach((o) => o.classList.remove('is-open'));
  });

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach((el) => observer.observe(el));
  }

  // Product recommendations (fetched via Section Rendering API so the
  // `recommendations` Liquid object is populated)
  const recSection = document.getElementById('product-recommendations');
  if (recSection && recSection.dataset.url) {
    fetch(recSection.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        recSection.innerHTML = html;
        recSection.querySelectorAll('.reveal').forEach((el) => el.classList.add('visible'));
      })
      .catch(() => {});
  }

  // Product gallery — swipe on mobile, prev/next arrows on desktop,
  // thumbnails still clickable to jump to a specific image.
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  const galleryMain = document.querySelector('.product-gallery__main');
  if (thumbs.length && mainImg && galleryMain) {
    const thumbList = Array.from(thumbs);
    let activeIndex = Math.max(0, thumbList.findIndex((t) => t.classList.contains('active')));

    const showSlide = (index) => {
      activeIndex = (index + thumbList.length) % thumbList.length;
      thumbList.forEach((t) => t.classList.remove('active'));
      thumbList[activeIndex].classList.add('active');
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = thumbList[activeIndex].dataset.full;
        mainImg.style.opacity = '1';
      }, 200);
    };

    thumbList.forEach((thumb, i) => {
      thumb.addEventListener('click', () => showSlide(i));
    });

    if (thumbList.length > 1) {
      // Desktop prev/next arrows
      const prevBtn = document.createElement('button');
      prevBtn.className = 'product-gallery__arrow product-gallery__arrow--prev';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';
      prevBtn.addEventListener('click', () => showSlide(activeIndex - 1));

      const nextBtn = document.createElement('button');
      nextBtn.className = 'product-gallery__arrow product-gallery__arrow--next';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
      nextBtn.addEventListener('click', () => showSlide(activeIndex + 1));

      galleryMain.appendChild(prevBtn);
      galleryMain.appendChild(nextBtn);

      // Mobile swipe
      let touchStartX = 0;
      let touchStartY = 0;
      galleryMain.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      galleryMain.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          dx < 0 ? showSlide(activeIndex + 1) : showSlide(activeIndex - 1);
        }
      }, { passive: true });
    }
  }

  // Product accordion — max-height is measured from real content height so
  // long content (e.g. multi-table size charts) is never clipped.
  const setAccordionHeight = (item) => {
    const content = item.querySelector('.accordion-content');
    if (content) content.style.maxHeight = item.classList.contains('open') ? content.scrollHeight + 'px' : '';
  };
  document.querySelectorAll('.accordion-item').forEach((item) => {
    const trigger = item.querySelector('.accordion-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      const siblings = item.parentElement.querySelectorAll('.accordion-item');
      siblings.forEach((i) => i.classList.remove('open'));
      siblings.forEach(setAccordionHeight);
      if (!isOpen) { item.classList.add('open'); setAccordionHeight(item); }
    });
    if (item.classList.contains('open')) setAccordionHeight(item);
  });
  window.addEventListener('resize', () => {
    document.querySelectorAll('.accordion-item.open').forEach(setAccordionHeight);
  });

  // Inline "Size Chart" trigger — opens the matching accordion item and scrolls to it
  document.querySelectorAll('.size-chart-trigger').forEach((btn) => {
    btn.addEventListener('click', function () {
      const item = document.getElementById(this.dataset.accordionTarget);
      if (!item) return;
      const siblings = item.parentElement.querySelectorAll('.accordion-item');
      siblings.forEach((i) => i.classList.remove('open'));
      siblings.forEach(setAccordionHeight);
      item.classList.add('open');
      setAccordionHeight(item);
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  // Size selector (quick-add cards: purely visual, variant id lives on the button itself)
  document.querySelectorAll('.product-card .size-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const group = this.closest('.size-selector');
      if (group) group.querySelectorAll('.size-btn').forEach((b) => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Product page: option buttons/swatches drive variant matching
  (function () {
    const form = document.getElementById('product-form');
    if (!form) return;
    let variants = [];
    try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (e) { variants = []; }

    const select = document.getElementById('variant-select');
    const addBtn = document.getElementById('add-to-cart-btn');
    const priceEl = document.querySelector('.product-info__price');

    const selectedOptions = () => {
      const groups = {};
      form.querySelectorAll('[data-option-index]').forEach((el) => {
        if (el.classList.contains('active')) groups[el.dataset.optionIndex] = el.dataset.value;
      });
      return groups;
    };

    const matchVariant = () => {
      const groups = selectedOptions();
      return variants.find((v) => {
        return Object.keys(groups).every((idx) => v.options[parseInt(idx, 10) - 1] === groups[idx]);
      });
    };

    const applyVariant = () => {
      const variant = matchVariant();
      if (!variant || !select || !addBtn) return;
      select.value = variant.id;
      const span = addBtn.querySelector('span');
      if (variant.available) {
        addBtn.disabled = false;
        if (span) span.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        if (span) span.textContent = 'Sold Out';
      }
      if (priceEl) {
        const fmt = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency: form.dataset.currency || 'AUD' }).format(cents / 100);
        const priceAmount = priceEl.querySelector('[itemprop="price"]');
        const compareAmount = priceEl.querySelector('.compare');
        if (priceAmount) { priceAmount.setAttribute('content', (variant.price / 100).toString()); priceAmount.textContent = fmt(variant.price); }
        if (variant.compare_at_price > variant.price) {
          if (compareAmount) { compareAmount.textContent = fmt(variant.compare_at_price); compareAmount.style.display = ''; }
        } else if (compareAmount) {
          compareAmount.style.display = 'none';
        }
      }
    };

    form.querySelectorAll('.size-btn, .color-swatch').forEach((el) => {
      el.addEventListener('click', function () {
        const group = this.closest('.size-selector, .color-swatches');
        if (group) group.querySelectorAll('.size-btn, .color-swatch').forEach((b) => b.classList.remove('active'));
        this.classList.add('active');
        applyVariant();
      });
    });

    applyVariant();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;
      const span = addBtn.querySelector('span');
      const original = span ? span.textContent : '';
      const variantId = select ? select.value : null;
      if (!variantId) return;
      addBtn.disabled = true;
      if (span) span.textContent = 'Adding...';
      plnoCartAdd(
        variantId,
        () => { if (span) span.textContent = 'Added to Cart'; setTimeout(() => { if (span) span.textContent = original; addBtn.disabled = false; }, 2200); },
        () => { if (span) span.textContent = 'Error — Try Again'; addBtn.disabled = false; }
      );
    });
  })();

  // Collection filter buttons
  document.querySelectorAll('.filter-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      this.closest('.collection-filters')?.querySelectorAll('.filter-btn').forEach((b) => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Cart quantity
  document.querySelectorAll('.cart-item__qty').forEach((qty) => {
    const dec = qty.querySelector('[data-action="decrease"]');
    const inc = qty.querySelector('[data-action="increase"]');
    const display = qty.querySelector('span');
    if (!dec || !inc || !display) return;
    dec.addEventListener('click', () => { const val = parseInt(display.textContent, 10); if (val > 1) display.textContent = val - 1; });
    inc.addEventListener('click', () => { display.textContent = parseInt(display.textContent, 10) + 1; });
  });

  // Newsletter form
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('input');
      const btn = this.querySelector('button');
      if (input && btn) {
        const original = btn.textContent;
        btn.textContent = 'Thank you';
        input.value = '';
        setTimeout(() => { btn.textContent = original; }, 3000);
      }
    });
  }

});
